module.exports = __webpack_public_path__ + "media/images/connect_ad_manager-5323b7528441367a86ef994f7b94ca8c.png";